import { render, staticRenderFns } from "./userMangement.vue?vue&type=template&id=529df0c6&"
import script from "./userMangement.vue?vue&type=script&lang=js&"
export * from "./userMangement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports